export default __webpack_public_path__ + "static/media/iconNuvemArquivoSelecionado.92307b36.svg";